import { Section, TableOfContent } from '../../../typings/interfaces';
import { DUTCH } from '../../../assets/images';
// Dutch - Nederlands
const NLSection: Section[] = [
  {
    name: '1: Referentie en overzicht',
    subSections: [
      {
        name: 'Voorwoord',
        page: 3,
      },
      {
        name: 'Doel en toepassing van de Field Guide',
        page: 4,
      },
      {
        name: 'Belangrijke definities',
        page: 5,
      },
      {
        name: 'Hiërarchie van beheersmaatregelen',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Motorvoertuig – Verkeersveiligheid',
        page: 9,
      },
      {
        name: 'Werken op hoogte',
        page: 12,
      },
      {
        name: 'Mobiel aangedreven apparatuur',
        page: 18,
      },
      {
        name: 'Lockout/Tagout – Energietoevoer uitschakelen',
        page: 22,
      },
      {
        name: 'Werken met elektriciteit',
        page: 25,
      },
      {
        name: 'Besloten ruimte',
        page: 29,
      },
      {
        name: 'Stortgoed en opslag',
        page: 32,
      },
      {
        name: 'Spoorveiligheid',
        page: 37,
      },
      {
        name: 'Graven en werken in greppels',
        page: 41,
      },
      {
        name: 'Heffen en takelen',
        page: 45,
      },
      {
        name: 'Gevaarlijke materialen',
        page: 49,
      },
      {
        name: 'Lassen en slijpen ("heet werk")',
        page: 52,
      },
    ],
  },
  {
    name: '3: Extra bronnen en hulpmiddelen',
    subSections: [
      {
        name: 'Werken boven en rondom water',
        page: 55,
      },
      {
        name: 'Vallende voorwerpen',
        page: 59,
      },
      {
        name: 'Atmosferische/gastesten',
        page: 61,
      },
      {
        name: 'Communicatie over chemische gevaren',
        page: 65,
      },
    ],
  },
  {
    name: '4: Veiligheids-beheerspraktijken van Cargill',
    subSections: [
      {
        name: 'Belangrijke terminologie',
        page: 70,
      },
      {
        name: 'Bepaling van ernstig letsel en dodelijke afloop (SIF)',
        page: 71,
      },
      {
        name: 'Classificatie van kans op ernstig letsel en op dodelijke afloop (SIFp)',
        page: 73,
      },
      {
        name: 'Tabel voor automatische SIF-bepaling van de criteria',
        page: 74,
      },
      {
        name: 'Human and Organizational Performance (HOP)',
        page: 76,
      },
    ],
  },
];

const NLTableOfContent: TableOfContent = {
  language: 'nl',
  sections: NLSection,
  label: 'Inhoudsopgave',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (nl_NL)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP-zakboek',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Dutch.pdf',
  source: DUTCH,
};

export default NLTableOfContent;
